// Hue-based initial avatar. Pass a stable `hue` (0-360) so the colour
// stays consistent for the same user across surfaces.

export function Avatar({ name, hue = 158, size = 24 }) {
  return (
    <div
      style={{
        width: size, height: size, borderRadius: 999,
        background: `oklch(0.7 0.1 ${hue})`,
        color: '#fff',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Inter, -apple-system, sans-serif',
        fontSize: Math.round(size * 0.42),
        fontWeight: 500,
        flex: '0 0 auto',
        letterSpacing: '-0.005em',
      }}
      title={name}
    >
      {(name || '?').slice(0, 1).toUpperCase()}
    </div>
  );
}
